import React from 'react'
import styled from 'styled-components'
import { Instagram, Facebook, Twitter, Youtube, Music, Globe } from 'lucide-react'
import colors from 'theme/colors'

const LOGO_HEIGHT = {
    xs: '48px',
    sm: '72px',
    md: '100px',
    lg: '140px',
}

const SOCIAL_ICON_MAP = {
    instagram: Instagram,
    facebook: Facebook,
    twitter: Twitter,
    youtube: Youtube,
    tiktok: Music,
    website: Globe,
}

function SocialLinks({ socialLinks }) {
    const entries = Object.entries(socialLinks || {}).filter(([, url]) => !!url)

    if (!entries.length) return null

    return (
        <SocialRow>
            {entries.map(([key, url]) => {
                const Icon = SOCIAL_ICON_MAP[key] || Globe
                return (
                    <SocialLink key={key} href={url} target='_blank' rel='noopener noreferrer'>
                        <Icon size={14} color={colors.secondaryPurple} />
                    </SocialLink>
                )
            })}
        </SocialRow>
    )
}

export default function SponsorSectionItems({ items = [], logoSize = 'md' }) {
    const height = LOGO_HEIGHT[logoSize] || LOGO_HEIGHT.md

    return (
        <Grid>
            {items.map((item) => {
                const logo = item.logo_url
                    ? <Logo src={item.logo_url} alt={item.name} $height={height} />
                    : <LogoPlaceholder $height={height}>{item.name}</LogoPlaceholder>

                return (
                    <ItemCard key={item.id}>
                        {item.link ? (
                            <LogoLink href={item.link} target='_blank' rel='noopener noreferrer'>
                                {logo}
                            </LogoLink>
                        ) : logo}
                        <SocialLinks socialLinks={item.social_links} />
                    </ItemCard>
                )
            })}
        </Grid>
    )
}

const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 8px;
`;

const ItemCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

const LogoLink = styled.a`
    display: flex;
`;

const Logo = styled.img`
    height: ${({ $height }) => $height};
    max-width: 220px;
    object-fit: contain;
`;

const LogoPlaceholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ $height }) => $height};
    min-width: 120px;
    max-width: 220px;
    padding: 0 16px;
    border-radius: 8px;
    background: ${colors.neutralDark};
    color: ${colors.nightDark};
    font-size: 13px;
    font-weight: 600;
    text-align: center;
`;

const SocialRow = styled.div`
    display: flex;
    gap: 6px;
`;

const SocialLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${colors.occasionalPurple}10;
`;
